const firebaseConfig = {
    apiKey: "AIzaSyChHwL7a9eSiXI9_Dwpc-zUqSrw_ute-rw",
    authDomain: "tomnet-counter.firebaseapp.com",
    projectId: "tomnet-counter",
    storageBucket: "tomnet-counter.firebasestorage.app",
    messagingSenderId: "955399981396",
    appId: "1:955399981396:web:7d94dbcce823d287a060c1",
    measurementId: "G-LWLYLWHCJC"
  };
export default firebaseConfig;